export default __webpack_public_path__ + "static/media/plus.4c62b6de.svg";